import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { UserSubscriptionCreationDialogComponent } from '~app/app/profile/components/user-subscription-creation-dialog/user-subscription-creation-dialog.component';
import { CurrentSubscription } from '~core/models/core.models';
import { SubscriptionStatusService } from '~app/app/~shared/services/subscription-status.service';

@Component({
  selector: 'user-subscription-card',
  standalone: false,
  templateUrl: './user-subscription-card.component.html',
  styleUrl: './user-subscription-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSubscriptionCardComponent extends BaseComponent {
  private _dialogService = inject(DialogService);
  private _subscriptionStatusService = inject(SubscriptionStatusService);

  currentSubscription$ =
    this._subscriptionStatusService.getCurrentSubscription();

  currentSubscriptions: CurrentSubscription[] = [];
  currentSubscription: CurrentSubscription = {} as CurrentSubscription;

  openSubscriptionDialog(currentSubscription: CurrentSubscription): void {
    const dialogRef = this._dialogService.open({
      component: UserSubscriptionCreationDialogComponent,
      config: {
        panelClass: ['mat-dialog-custom', 'w-[600px]'],
        backdropClass: ['bg-black/50'],
        disableClose: false,
        maxWidth: '600px'
      }
    });
    dialogRef.componentRef?.setInput(
      'currentSubscriptions',
      currentSubscription
    );
  }
}
